import React from 'react';
import './Switch.css';

const Switch = ({ checked, onChange, label, className = '', ...props }) => {
  return (
    <div className={`switch-container ${className}`}>
      <label className="switch-label-wrapper">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="switch-input"
          {...props}
        />
        <span className="switch-slider"></span>
      </label>
      {label && <span className="switch-label">{label}</span>}
    </div>
  );
};

export default Switch; 